import { base, BaseCoreEventConstants, dispatcher, EventConstants, ISpineData, Loading, SpineBase } from "@quest/base-core";
import { BigWinView } from "@quest/murka-games-behavior-leopard/dist";

export class BigWinViewGame extends BigWinView {
    /*Override initialiseElements to call initializeComponents*/
    protected initialiseElements():void{
        super.initialiseElements();
        this.initializeComponents();
    }

    protected createSpine(json: ISpineData): SpineBase {
        if (Loading.isSpineLoaded(json.image)) {
              //@ts-expect-error
              const spine = new base.Spine(json);
              if (json.parent) {
                this.containers[json.parent].addChild(spine);
              } else {
                this.addChild(spine);
              }
              json.key = json.key ? json.key : json.id;
              this.spines[json.key] = spine;
              this.allComponents[json.id] = spine;
              dispatcher.fireEvent(EventConstants.COMPONENT_CREATED, spine);
              return spine;
            } else {
              dispatcher.on(BaseCoreEventConstants.FILE_LOADED, (evt) => {
                if (
                  (evt.data === json.image || evt.data === json.image + ".png" || evt.data === json.image + ".webp") &&
                  Loading.isImageLoaded(evt.data)
                ) {
                  evt.remove();
                  // adding delay so that the currentGame.cache.spine has the entry of the loaded spine, if it is not in cache it does not create the spine and we do not have
                  // any event as of now by which we can check if the spine is loaded in the cache after the files are loaded fileLoadComplete on our loader is called before fileLoadComplete of Spine
                  // utils.delayedCall(core.base.constants.delayKeys.SPINE_CREATION_DELAY, 1, (jsonArray: ISpineData[]) => {
                  this.createSpine(json);
                  // }, this, json);
                }
              });
            }
    }
}

